import React, { useState, useEffect } from "react";
import "./Home.css";
import { useNavigate } from "react-router-dom";
import nimal from "../../assets/DummyImages/nimal.png";
import saduni from "../../assets/DummyImages/saduni.png";
import rashmi from "../../assets/DummyImages/rashmi.png";
import Christofer from "../../assets/DummyImages/Dilan-Christofer.png";
import ShainiFernando from "../../assets/DummyImages/Shaini-Fernando.png";
import SunijaWelikadaarachchi from "../../assets/DummyImages/Sunija-Welikadaarachchi.png";
import AshenSandaru from "../../assets/DummyImages/Ashen-Sandaru.png";
import HirunBro from "../../assets/DummyImages/Hirun-Bro.png";
import NethmiBhagya from "../../assets/DummyImages/Nethmi-Bhagya.png";
import TharinduDilshan from "../../assets/DummyImages/Tharindu-Dilshan.png";
import Chanuthdasanayaka from "../../assets/DummyImages/Chanuth-dasanayaka.png";
import SuraniMalith from "../../assets/DummyImages/Surani-Malith.png";
import bgImage from "../../assets/HomeSection/main-bg.png";
import {
  englishData,
  sinhalaData,
  tamilData,
} from "../../dummyData/HomeDummyData";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import AdsComponent from "../../Components/AdsComponent/AdsComponent";
import OurLessons from "../../Components/HomePageMain/OurLessons/OurLessons";
import PapersHome from "../../Components/HomePageMain/PapersHome/PapersHome";
import DrivingHandbook from "../../Components/HomePageMain/DrivingHandbook/DrivingHandbook";
import OurServices from "../../Components/HomePageMain/OurServices/OurServices";
import YourJourney from "../../Components/HomePageMain/YourJourney/YourJourney";
import OurApps from "../../Components/HomePageMain/OurApps/OurApps";

const REVIEWS_PER_VIEW_DESKTOP = 3;
const REVIEWS_PER_VIEW_MOBILE = 1;

function Home() {
  const navigate = useNavigate();
  const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(sinhalaData[0]);
  const [startIndex, setStartIndex] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);

  const handleOpenLearners = () => {
    navigate("/driving-handbook");
  };

    // const slides = [
    //   {
    //     image: heroImg,
    //     link: "/sri-lanka-driving-license-exam-papers",
    //     alt: "hire Personal Driving Instructor online in Sri Lanka",
    //   },
    //   {
    //     image: heroImg2,
    //     link: "/driving-license-video-guide",
    //     alt: "get Driving License with online Instructor in Sri Lanka",
    //   },
    // ];

  useEffect(() => {
    switch (selectedLanguage.value) {
      case "english":
        setLanguage(englishData[0]);
        break;
      case "tamil":
        setLanguage(tamilData[0]);
        break;
      default:
        setLanguage(sinhalaData[0]);
        break;
    }
  }, [selectedLanguage]);

  useEffect(() => {
    const interval = setInterval(() => {
      setStartIndex((prev) => (prev + 1) % reviews.length);
    }, 10000);

    return () => clearInterval(interval);
  }, [reviews.length]);

  const getVisibleReviews = (count) => {
    const visible = [];
    for (let i = 0; i < count; i++) {
      visible.push(reviews[(startIndex + i) % reviews.length]);
    }
    return visible;
  };

    // useEffect(() => {
    //   const interval = setInterval(() => {
    //     setCurrentSlide((prev) => (prev + 1) % slides.length);
    //   }, 5000);

    //   return () => clearInterval(interval);
    // }, [slides.length]);

    useEffect(() => {
      setCurrentSlide(0);
    }, [language]);

    useEffect(() => {
      if (!language?.slides?.length) return;

      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % language.slides.length);
      }, 5000);

      return () => clearInterval(interval);
    }, [language]);

    const handleNavigatePages = (link) => {
      navigate(link);
      console.log("Navigating to:", link);
    };

  return (
    <>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>
          Driving License Exam Preparation in Sri Lanka | Lanka Learners
        </title>
        <meta
          name="description"
          content="Pass your Sri Lanka driving license exam with confidence. Practice MCQs, road signs, handbooks, and mock tests online at Lanka Learners."
        />
        <meta name="author" content="Lanka Learners" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        {/* Replace with actual image URL */}
        <meta name="robots" content="index, follow" />
        {/* Additional Meta Tags */}
        <link rel="canonical" href="https://lankalearners.lk/" />
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Lanka Learners | Driving License Exam Preparation"
        />
        <meta
          property="og:description"
          content="Prepare for your driving license exams in Sri Lanka with interactive Practice MCQs, handbooks, road signs and driving rules online and more. Join Lanka Learners today!"
        />
        <meta property="og:url" content="https://lankalearners.lk/" />
        <meta
          property="og:image"
          content="https://lankalearners.lk/images/sldl.png"
        />{" "}
        {/* Replace with actual image URL */}
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Lanka Learners | Driving License Exam Preparation"
        />
        <meta
          name="twitter:description"
          content="Learn everything you need to pass your driving license exams in Sri Lanka with Lanka Learners."
        />
        <meta
          name="twitter:image"
          content="https://lankalearners.lk/images/sldl.png"
        />{" "}
        <script type="application/ld+json">
          {`
                    {
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        "name": "Lanka Learners",
                        "url": "https://lankalearners.lk/",
                        "logo": "https://lankalearners.lk/images/logo.png",
                        "description": "Lanka Learners is Sri Lanka’s top platform for driving exam preparation.",
                        "sameAs": [
                            "https://www.facebook.com/mechsit",
                            "https://mecsit.com/",
                            "https://www.instagram.com/LankaLearners",
                            "https://www.linkedin.com/company/mechsit",
                            "https://play.google.com/store/apps/details?id=appinventor.aimechsita.sldl&hl=en",
                            "https://www.youtube.com/@mechsitapps",
                            "https://play.google.com/store/apps/details?id=appinventor.aimechsita.sldl.tm&hl=en",
                            "https://apps.apple.com/lk/app/mechsit-sri-lanka-drivers-exam/id1599318476",
                        ],
                         "contactPoint": {
                            "@type": "ContactPoint",
                            "contactType": "customer support",
                            "email": [
                                "lankalearnerslk@gmail.com",
                                "info@mechsit.com"
                            ],   
                            "availableLanguage": ["en", "si", "ta"]
                        }
                    }
                    `}
        </script>
      </Helmet>
      <main>
        <section
          className="hero-section px-3 px-md-5 min-vh-100 d-flex align-items-center"
          style={{ backgroundImage: `url(${bgImage})` }}
        >
          <div className="overlay"></div>
          <div className="overlay-2"></div>
          <h1 className="visually-hidden">
            Driving License Exam Preparation in Sri Lanka
          </h1>
          <p className="visually-hidden">
            Lanka Learners provides comprehensive resources, guides, road signs,
            mock tests, and driving handbooks online to help you successfully
            prepare for your driving license exams in Sri Lanka.
          </p>
          <div className="container position-relative">
            <div className="row align-items-center pt-0 pt-md-5">
              {/* Left Section */}
              <div className="col-md-6  mb-4 mb-md-0 d-flex flex-column justify-content-between h-100">
                <h2 className="hero-title text-center text-md-start">
                  {language.titleMain}
                  <br />
                  <span className="highlight">{language.titleHigh}</span>{" "}
                  {language.titleEnd}
                </h2>
                <h3 className="hero-subtitle text-center text-md-start">
                  {language.subTitle}
                </h3>
                <div className="cta-wrapper">
                  <button
                    className="btn-main-hero"
                    onClick={handleOpenLearners}
                  >
                    {language.regBtn}
                  </button>

                  <div className="user-count-box">
                    <span className="user-number">500K +</span>
                    <span className="user-text">Users</span>
                  </div>
                </div>
              </div>

              {/* Right Section (Image) */}
              <div className="col-12 col-md-6 mb-4 mb-md-0 d-flex justify-content-center">
                <div className="slider-container-main">
                  <div
                    className="slider-track"
                    style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                  >
                    {language?.slides?.map((slide, i) => (
                      <div key={i} className="main-slide-item">
                        <button
                          type="button"
                          className="slider-button"
                          onClick={() => handleNavigatePages(slide.link)}
                        >
                          <div className="sld-image-wrapper">
                            <img
                              src={slide.image}
                              alt={slide.alt}
                              className="tile-image-main"
                            />
                          </div>
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Review Cards */}
            <div className="reviews-section mt-5">
              {/* ===== Desktop & Tablet Grid View ===== */}
              <div className="row g-4 justify-content-center d-none d-sm-flex">
                {getVisibleReviews(REVIEWS_PER_VIEW_DESKTOP).map((r, i) => (
                  <div className="col-md-4 col-sm-6" key={i}>
                    <div className="review-card p-3 rounded-4 shadow-sm bg-white h-100">
                      <div className="d-flex align-items-center mb-2">
                        <img
                          src={r.img}
                          alt={r.name}
                          className="rounded-circle me-2"
                          width={45}
                          height={45}
                        />
                        <div>
                          <h6 className="mb-0 fw-bold">{r.name}</h6>
                          <small className="text-muted">{r.rating}</small>{" "}
                          <span className="text-warning">
                            {"★".repeat(Math.floor(r.rating))}
                            {"☆".repeat(5 - Math.floor(r.rating))}
                          </span>{" "}
                        </div>
                      </div>
                      <p className="text-muted small mb-0">{r.review}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* ===== Mobile Horizontal Scroll View ===== */}
              <div className="d-flex d-sm-none min-vw-80 review-horizontal-scroll-container mt-3">
                <div className="review-horizontal-scroll-inner">
                  {getVisibleReviews(REVIEWS_PER_VIEW_MOBILE).map((r, i) => (
                    <div className="review-horizontal-slide me-3" key={i}>
                      <div className="review-card p-3 rounded-4 shadow-sm bg-white">
                        <div className="d-flex align-items-center mb-2">
                          <img
                            src={r.img}
                            alt={r.name}
                            className="rounded-circle me-2"
                            width={45}
                            height={45}
                          />
                          <div>
                            <h6 className="mb-0 fw-bold">{r.name}</h6>
                            <small className="text-muted">
                              {r.rating}
                            </small>{" "}
                            <span className="text-warning">
                              {"★".repeat(Math.floor(r.rating))}
                              {"☆".repeat(5 - Math.floor(r.rating))}
                            </span>{" "}
                          </div>
                        </div>
                        <p className="text-muted small mb-0">{r.review}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        <YourJourney />
        <AdsComponent />
        <OurLessons />
        <PapersHome />
        <DrivingHandbook />
        <OurServices />
        <OurApps />
      </main>
    </>
  );
}

export default Home;

const reviews = [
  {
    name: "Nimal Karunarathna",
    rating: 5.0,
    review:
      "Good Platform To Prepare For The Driving License Exam. The Papers Cover All Sections, But I Wish There Were More Practice Sets.",
    img: nimal,
  },
  {
    name: "Saduni Nimesha",
    rating: 5.0,
    review:
      "The Papers Are Useful, But The Interface Can Be Improved. Still, It’s A Good Resource For Learners.",
    img: saduni,
  },
  {
    name: "Rashmi Perera",
    rating: 5.0,
    review:
      "Excellent Resource! The SLDL Web Papers Gave Me The Exact Practice I Needed. I Felt Well-Prepared And Stress-Free On Exam Day.",
    img: rashmi,
  },
  {
    name: "Dilan Christofer",
    rating: 5.0,
    review:
      "Best app for SL driving license test. Thank you ! App been really helpful.",
    img: Christofer,
  },
  {
    name: "Shaini Fernando",
    rating: 5,
    review:
      "I did an exam today and I got 36/40. There were like 35 questions from this app. It was really helpful",
    img: ShainiFernando,
  },
  {
    name: "Sunija Welikadaarachchi",
    rating: 5.0,
    review:
      "This is an excellent application and an excellent and committed service!.",
    img: SunijaWelikadaarachchi,
  },
  {
    name: "Ashen Sandaru",
    rating: 5.0,
    review: "really helpful app good",
    img: AshenSandaru,
  },
  {
    name: "Hirun Bro",
    rating: 5,
    review: "සුපිරි ඇප් එක ,ගොඩක් ප්‍රයෝජනවත් ❤️‍🩹",
    img: HirunBro,
  },
  {
    name: "Nethmi Bhagya",
    rating: 5.0,
    review:
      "සුපිර් ඇප් එක..ප්‍රයෝජනව ඇප් එකක්..තව එක ඉල්ලීමක්..ඔයාල කම්පැනියක් නම් ඩ්‍රයිව් කරන්න ගේම් එකකුත් හැදුවනම් හොදයි මෙම නිති රීති හා දැනුම සමග..",
    img: NethmiBhagya,
  },
  {
    name: "Tharindu Dilshan",
    rating: 5.0,
    review: "ඇත්තටම හොඳ ඇප් එකක් ගොඩක් දේවල් ඉගෙන ගන්න ලේසියි",
    img: TharinduDilshan,
  },
  {
    name: "Chanuth dasanayaka",
    rating: 5,
    review: "සුපිරි ලොකු උදව්වක් මෙක 💓😘",
    img: Chanuthdasanayaka,
  },
  {
    name: "Surani Malith",
    rating: 5.0,
    review:
      "ගොඩාක් ලේසියි..බොහොම ස්තූතියි",
    img: SuraniMalith,
  },
];
